import { useEffect, useRef } from "react";
import { api, apiUrls } from "../utils/api";
import { useAuthStore, type CurrentUser, type Wallet } from "../store/authStore";

/**
 * Bootstraps auth on app mount: if tokens exist in localStorage,
 * fetches the current user + wallet from the backend and hydrates
 * the auth store.  Runs once per mount or when tokens change.
 */
export function useAuthBootstrap() {
  const tokens = useAuthStore((s) => s.tokens);
  const setUser = useAuthStore((s) => s.setUser);
  const setWallet = useAuthStore((s) => s.setWallet);
  const logout = useAuthStore((s) => s.logout);
  const fetched = useRef(false);

  useEffect(() => {
    if (!tokens?.access?.token) {
      setUser(null);
      setWallet(null);
      fetched.current = false;
      return;
    }

    if (fetched.current) return;
    fetched.current = true;

    (async () => {
      try {
        const res = await api.get<{ user?: CurrentUser; wallet?: Wallet }>(
          apiUrls.getUser,
        );
        if (res.data.user) setUser(res.data.user);
        if (res.data.wallet) setWallet(res.data.wallet);
      } catch {
        // Token invalid — clear auth
        logout();
      }
    })();
  }, [tokens, setUser, setWallet, logout]);
}
